import React, { PropsWithChildren } from "react";

type TableBodyProps = {
  className?: string;
};

export default function TableBody(props: PropsWithChildren<TableBodyProps>) {
  return <tbody className={props.className}>{props.children}</tbody>;
}
